enum SkapaIconDurationEnum {
	simple = '150ms',
	average = '300ms',
	complex = '600ms'
}

export default SkapaIconDurationEnum;
